// Module
var code = "<a class=\"btn blue-dark subFormControl\"> <i class=\"fa fa-copy\"></i> Copy </a> ";
// Exports
export default code;